function NotificationUnreadDot() {
  return (
    <span className="mr-[0.8rem] inline-block h-[0.8rem] min-w-[0.8rem] rounded-full bg-brand-secondary"></span>
  );
}

export { NotificationUnreadDot };
